// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { resolveColor, safeColor } from "@insite/mobius/utilities";
import color from "@rugby/XDL/Utilities/color";
import Color from "color";
import { css } from "styled-components";

const scrollbarColor = {
    track: color("common.ui2", 0.5),
    thumb: color("common.ui2", 1),
};

export const styledScrollbar = (width = 5) => {
    return ({ theme }: any) => css`
        scrollbar-width: thin;
        scrollbar-color: ${resolveColor("common.ui3", theme)} ${color("common.border", 0.3)};

        &::-webkit-scrollbar {
            width: ${width}px;
            height: ${width}px;
        }
        &::-webkit-scrollbar-track {
            background: ${color("common.border", 0.3)};
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${resolveColor("common.ui2", theme)};
            border-radius: 6px;
            border: 3px solid transparent;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: ${(props: any) => {
                const hoverColor = resolveColor("common.ui2", props.theme);
                return Color(safeColor(hoverColor))["darken"](0.3).toString();
            }};
        }
    `;
};

export const xFlexGap = (gap: number) => {
    return css`
        display: inline-flex;
        flex-wrap: wrap;

        margin: -${gap}px 0 0 -${gap}px;
        width: calc(100% + ${gap}px);

        & > * {
            margin: ${gap}px 0 0 ${gap}px;
        }
    `;
};
